import 'daterangepicker';

document.addEventListener('DOMContentLoaded', () => {
	const jobDateRange = document.getElementById('selectJobsForDate');

	if (!jobDateRange) {
		return;
	}

	$('#selectJobsForDate').daterangepicker({
		opens: 'left',
		locale: {
			format: 'DD/MM/YYYY'
		}
	}, function (start, end, label) {
		// Format the start and end dates
		const dateStart = start.format('YYYY-MM-DD');
		const dateEnd = end.format('YYYY-MM-DD');

		// Get the current URL without any query parameters
		const currentUrl = window.location.origin + window.location.pathname;

		// Construct the new URL with the date range query parameters
		const newUrl = `${currentUrl}?date_start=${dateStart}&date_end=${dateEnd}`;

		// Redirect to the new URL
		window.location.href = newUrl;
	});

});